var _effectorFileName = "/src/widgets/layouts/main/pricing/pricing-card.tsx";
import Link from 'next/link';
import { ExternalLinkIcon } from '@radix-ui/react-icons';
import CheckMarkIcon from '@/shared/components/icons/checkmark-icon';
import { Button } from '@/shared/components/ui/button';
import { cn } from '@/shared/lib/cn';
interface Prices {
  current: number;
  prev?: number;
}
interface CardProps {
  header: string;
  prices?: Prices;
  description?: string;
  benefitsList?: Array<string>;
  isServicePrimary: boolean;
  link: string;
  isExternalLink: boolean;
}
export const PricingCard = (props: CardProps) => {
  const {
    header,
    prices,
    description,
    benefitsList,
    isServicePrimary,
    link,
    isExternalLink
  } = props;
  return <div className={cn('relative flex w-full flex-col gap-4 overflow-hidden rounded-2xl border bg-background/95 p-4 text-black backdrop-blur supports-[backdrop-filter]:bg-background/60 dark:text-white', {
    'min-h-[380px] gap-5 border-2 border-brand-accent-normal shadow-lg shadow-neutral-500 dark:border-brand-accent-light dark:shadow-neutral-600 lg:p-6': isServicePrimary
  })}>
      <div className={cn('mb-auto flex h-24 flex-col justify-between', {
      'h-28 sm:h-32': isServicePrimary
    })}>
        <div>
          <h3 className="text-base font-semibold leading-5 sm:text-base lg:text-lg">{header}</h3>

          {description && <p className={cn('mt-1 text-xs leading-4 text-black/70 dark:text-white', {
          'text-sm leading-5': isServicePrimary
        })} dangerouslySetInnerHTML={{
          __html: description
        }} />}
        </div>

        {prices && <div className={cn('flex flex-row items-center gap-1', {
        'gap-2': isServicePrimary
      })} style={{
        opacity: 1,
        transform: 'none'
      }}>
            {prices.prev && <p className={cn('inline-block whitespace-nowrap text-sm !leading-tight text-brand-accent-normal line-through dark:text-brand-accent-light lg:text-sm lg:leading-tight', {
          'lg:text-base': isServicePrimary
        })}>
                {prices.prev}
              </p>}

            <p className={cn('text-xs leading-none text-black dark:text-white lg:leading-none', {
          'text-sm lg:text-base lg:leading-tight': isServicePrimary
        })}>
              <span className={cn('inline text-xl font-semibold tracking-tight sm:text-lg', {
            'text-xl leading-tight sm:text-lg lg:text-xl': isServicePrimary
          })}>
                {prices.current}
              </span>
              &nbsp;&#8381;&nbsp;/ месяц (8&nbsp;занятий)<span className="text-muted-foreground">*</span>
            </p>
          </div>}
      </div>

      <Link href={link} aria-label="Перейти на страницу услуги" target={isExternalLink ? '_blank' : '_self'} rel="noopener noreferrer">
        <Button variant="cta" className="w-full" aria-label="Перейти на страницу услуги">
          Подробнее{' '}
          {isExternalLink && <ExternalLinkIcon className="ml-1 size-4 transition-all duration-300 ease-out group-hover:translate-x-1" />}
        </Button>
      </Link>

      {benefitsList && <>
          <hr className="m-0 h-px w-full border-none bg-gradient-to-r from-neutral-200/0 via-neutral-500/30 to-neutral-200/0" />

          <ul className={cn('flex flex-col gap-2 font-normal lg:gap-3', {
        'gap-3 lg:gap-4': isServicePrimary
      })}>
            {benefitsList.map((benefit, index) => {
          return <li key={index} className={cn('flex items-center gap-3 text-xs font-medium text-black dark:text-white lg:text-sm', {
            'text-sm lg:text-base': isServicePrimary
          })}>
                  <CheckMarkIcon className="h-5 w-5 shrink-0 rounded-full bg-brand-accent-light p-[2px] text-white dark:bg-brand-accent-normal" />
                  <span className="flex" dangerouslySetInnerHTML={{
              __html: benefit
            }} />
                </li>;
        })}

            <li className="flex items-center gap-3 text-xs font-medium text-muted-foreground dark:text-white lg:text-sm">
              <span className="flex">
                <span className="text-muted-foreground">*</span>
                Оплата возможна в разных валютах
              </span>
            </li>
          </ul>
        </>}
    </div>;
};